
export const de_DE = {
  message: {
    OnlyForBuisness: 'Nur für Geschäftskunden, Preise zzgl. gesetzl. MwSt.',
    contact: 'Kontakt',
    signIn: 'Einloggen',
    signUp: 'Registrieren',
    blog: 'Blog',
    home: 'Start',
    price: 'Preis',
    password: 'Passwort',
    repeatPassword: 'Passwort wiederholen',
    email: 'E-Mailadresse',
    username: 'Benutzername',
    show: 'ansehen',
    acceptTerms: 'Ich stimme den AGBs zu',
    alreadyAccount: 'Bereits registriert?',
    forgotEmail: 'E-Mail vergessen?',
    forgotPassword: 'Passwort vergessen?',
    send: 'Senden',
    successfullSendet: 'erfolgreich gesendet',
    successfullSaved: 'erfolgreich gespeichert',
    dashboard: 'Dashboard-Übersicht',
    goTo: 'zu {name} wechseln',
    add: '{name} hinzufügen',
    app: 'App',
    youAreNotLoggedIn: 'Momentan nicht eingeloggt',
    logout: 'ausloggen',
    confirm: '{name} jetzt bestätigen',
    edit: '{name} bearbeiten',
    profile: 'Profil',
    board: 'Befragung | Befragungen',
    boardOverview: 'Befragungs-Übersicht',
    feedback: 'Bewertung | Bewertungen',
    website: 'Website',
    preview: 'Vorschau',
    createNew: '{name} neu erstellen',
    embed: 'einbetten',
    question: 'Frage | Fragen',
    delete: 'löschen',
    deletionRequest: "Löschung beantragen",
    comment: "Kommentar",
    yes: 'ja',
    no: 'nein',
    duplicate: 'duplizieren',
    allDataWillBeDeleted: 'Alle Daten werden gelöscht',
    search: 'Suche',
    date: 'Datum',
    noEntry: 'kein Eintrag | keine Einträge',
    back: 'zurück',
    default: 'Standard-{name}',
    color: 'Farbe | Farben',
    imprint: 'Impressum',
    privacy: 'Datenschutz',
    terms: 'AGBs',
    company: 'Firma | Firmen',
    first_name: 'Vorname',
    last_name: 'Nachname',
    adress: 'Adresse | Adressen',
    zip: 'Postleitzahl',
    city: 'Stadt | Städte',
    background_color: 'Hintergrund-Farbe',
    text_color: 'Text-Farbe',
    accent_color: 'Akzent-Farbe',
    getValidationEmail: 'Bestätigungs-Link per E-Mail zur Echtheitsprüfung erhalten',
    getValidationSMS: 'Bestätigungs-Link per SMS zur Echtheitsprüfung erhalten',
    idea: 'Idee | Ideen',
    suggestionForImprovement: 'Verbesserungsvorschlag | Verbesserungsvorschläge',
    mobileNumber: 'Handynummer',
    notPublic: 'Nicht veröffentlicht',
    public: "Öffentlich einsehbar",
    personalData: 'Persönliche Angaben',
    validation: 'Validierung',
    validationLinkSendedTo: 'Validierungs-Link erfolgreich an {name} gesendet!',
    thankYou: 'Danke',
    save: '{name} jetzt speichern',
    badge: 'Bewertungs-Label | Bewertungs-Labels',
    embedCode: 'Einbettungs-Code',
    embedHint: 'Einbettungscode auf der eigenen Website bitte zwischen <body> und </body> einfügen',
    passwordProtected: '{name} ist Passwortgeschützt | {name} sind Passwortgeschützt',
    whyXStars: 'Warum {stars} Sterne?',
    optional: 'optional',
    ofStars: '{current} von {all} Sternen',
    star: 'Stern | Sterne',
    settings: 'Einstellung | Einstellungen',
    function: 'Funktion | Funktionen',
    invitation: 'Einladung | Einladungen',
    successfullValidated: 'Bewertung wurde erfolgreich validiert',
    targetPage: 'Zielseite | Zielseiten',
    reasonWhy: 'Begründung',
    pleaseInsertReasonWhy: '{name} - Bitte jetzt eine Stellungnahme hinterlegen oder die Bewertung löschen. Anschließend wird die Bewertung durch das Support-Team geprüft.',
    userChat: 'Kunden-Chat',
    service: 'Service',
    unreadChats: 'ungelesene Chats',
    falseLogin: 'Benutzername oder Passwort ist falsch',
    next: 'weiter',
    previous: 'zurück',
    today: 'heute',
    yesterday: 'gestern',
    thisYear: 'dieses Jahr',
    lastYear: 'letztes Jahr',
    thisMonth: 'dieser Monat',
    lastMonth: 'letzter Monat',
    menu: 'Menü',
    logo: 'Logo',
    banner: 'Banner-Bild',
    backgroundImage: "Hintergrund-Bild",
    cookie: 'Cookie-Einstellung',
    allowEssentialCookies: 'Nur essenzielle Cookies',
    allowAllCookies: 'Alle Cookies',
    notifyMeViaEmail: 'Per E-Mail über eingehende Bewertungen benachrichtigen',
    importFromHitorShit: 'Bewertungen von HitorShit importieren',
    writeAReview: 'Rezension schreiben',
    slider: "Slider-Box",
    table: "Tabelle",
    floating: "Fließend",
    answerFromAdmin: "Antwort vom Inhaber"
  },

  email: {

    registerEmail: {
      title: 'Erfolgreich gespeichert',
      text: 'Bitte jetzt Emails aufrufen.\n\nWir haben eine Registrierungs-Bestätigung gesendet. In dieser E-Mail befindet sich ein Verifizierungs-Link. Mit Klick auf den Link ist die Registrierung abgeschlossen.\n\nBitte auch Spam-Ordner checken.\n\nNach der Verifizierung können im Kunden-Login-Bereich alle Funktionen genutzt werden.'
    },
    conflictEmail: {
      title: 'Es besteht ein Konflikt mit einer Bewertung',
      text: 'Hallo {name},\nmit der Bewertung auf {url} bin ich nicht einverstanden.\n\nBEGRÜNDUNG\n---------------------------------\n{reasonWhy}\n---------------------------------\n\nIch bitte um das eigenständige Löschen dieser Bewertung oder um eine kurze Stellungnahme. Der Link dazu wird dieser Nachricht automatisch beigefügt. Danke für eine Rückmeldung binnen einer Frist von 7 Tagen.\n\n{user}\n\n---------------------------------\nLink zur Stellungnahme:\n{link}\n---------------------------------'
    },
    invitationEmail: {

      text: 'Hallo.\nZu dieser E-Mail gibt es eine Einladung zur Befragung: \'{board}.\'\n\nÜber folgenden Link kann eine Bewertung abgegeben werden:\n{link}\n\nVielen Dank für kurzfristiges Feedback!\n\n{name}'
    },
    validationEmail: {
      title: 'Bitte Bewertung validieren',
      text: 'Bitte jetzt die Bewertung durch Klick auf den Link freischalten:\n\n{link}'
    }
  },
  demo: {
    questions: 'Wie bewerten Sie die Produktqualität? | Wie bewerten Sie den Service?',
    targetText: 'Danke für die ehrliche {star}-Sterne Bewertung'
  },
  company: {
    name: 'HitKlick',
    benefits: ['Befragungen erstellen', 'Bewertungen erhalten', 'Auf Website einbetten'],
    mainBenefit: 'Reputation steigern'
  },
  terms: {
    privacyAccept: 'Ich stimme der Erhebung und Verarbeitung meiner personenbezogenen Daten ausdrücklich zu.',
    termsAccept: 'Ich stimme den Allgemeinen Geschäftsbedingungen zu.'
  },
  home: {
    infoblock: {
      title: 'Echtheitsgeprüfte Kundenbewertungen für das seriöse, vertrauenswürdige Reputationsmanagement',
      description: [
        ['Bewertungs-Management', 'Ehrliches Kundenfeedback erhalten und veröffentlichen. Einfach. Direkt. Ehrlich.'],
        ['Einbinden oder eigene Bewertungs-Website', 'Bewertungen auf der eigenen Website veröffentlichen. Oder mit wenigen Klicks eine Bewertungs-Website mit individuellen Inhalten erstellen. '],
        ['Kostenfrei für alle', 'Hitklick.com ist kostenlos nutzbar für Privatpersonen und Unternehmen. ']

      ]
    }
  }
}
